import styled from 'styled-components'

import BaseButton from 'components/Button'

import { colors } from 'styles/colors'

export const Container = styled.div`
    margin-top: 40px;
    width: 100%;
    min-height: 750px;
    display: flex;
    perspective: 2000px;
`

export const Card = styled.div`
    width: 100%;
    position: relative;
    transform-style: preserve-3d;
    transition: transform 0.6s ease-in-out;
    transform: rotateY(0deg);
    background: #fff;
    box-shadow: 0 5px 16px 0 #4949491f;
    border-radius: 16px;

    display: flex;
    flex-direction: column;

    &.flipped {
        transform: rotateY(180deg);
    }

    &.tudo {
        height: 800px;
    }

    &.pod {
        height: 880px;
    }
`

export const Content = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;

    justify-content: space-between;
`

export const Front = styled.div`
    height: 100%;
    width: 100%;
    backface-visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
`

export const Back = styled.div`
    height: 100%;
    width: 100%;
    backface-visibility: hidden;
    position: absolute;
    top: 0;
    left: 0;
    transform: rotateY(180deg);
`

export const DivImage = styled.div`
    width: 100%;
    background: linear-gradient(
        to bottom,
        ${(p) => p.$gradientColor} 70%,
        white 30%
    );
    border-radius: 16px;

    display: flex;
    justify-content: center;
    align-items: flex-start;

    padding: 40px 0;

    img {
        display: block;
        margin: 0 auto;
        width: 130px;
    }

    @media (max-width: 500px) {
        img {
            width: 100px;
        }
    }
`

export const Info = styled.div`
    font-style: normal;
    color: #282828;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;

    > * + * {
        margin-top: 10px;
    }

    :not(:first-child) {
        padding: 0 20px;
    }

    @media (max-width: 500px) {
        > * + * {
            margin-top: 10px;
        }
    }
`

export const Title = styled.h1`
    font-weight: 300;
    font-size: 26px;
    line-height: 150%;
    text-transform: uppercase;

    color: ${colors.black};

    @media (max-width: 500px) {
        font-size: 24px;
    }
`

export const Subtitle = styled.h2`
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    text-transform: uppercase;

    color: ${(p) => p.$color};

    @media (max-width: 500px) {
        font-size: 20px;
    }
`

export const Desc = styled.p`
    font-weight: 700;
    font-size: 18px;
    line-height: 150%;
    color: #282828;

    @media (max-width: 500px) {
        font-size: 16px;
    }
`

export const Text = styled.p`
    font-size: 16px;
    line-height: 150%;
    color: #282828;

    @media (max-width: 500px) {
        font-size: 14px;
    }
`

export const Link = styled.a`
    font-size: 12px;
    color: ${colors.defaultGreen};
    text-transform: uppercase;
    line-height: 14px;
`

export const Actions = styled.div`
    padding: 0 20px 20px;

    font-style: normal;
    color: #282828;

    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: center;

    text-align: center;

    > * + * {
        margin-top: 10px;
    }
`

export const Button = styled(BaseButton)`
    padding: 15px;
    width: 100%;
    bottom: 10px;
`
